// Legacy data key mappings (your existing keys)
// [2026-02-10 TRC] TODO: make this a part of what gets returned by getDisplayInfo() and lives in formatting.tsx.semanticTermToDisplayInfo
export const DATA_KEY_COLORS: { [key: string]: string } = {
    // Cash flow related
    cashFlowCumulative: "var(--audette-purple-300)",
    carbonPolicyCostSavings: "var(--audette-green-200)",
    incrementalCost: "var(--audette-gray-400)",
    likeForLikeCost: "var(--audette-gray-300)",
    totalLikeForLikeCost: "var(--audette-gray-300)",
    totalIncrementalCost: "var(--audette-gray-500)",
    implementationCost: "var(--audette-gray-500)",
    utilityCostSavingsElectricity: "var(--audette-green-600)",
    utilityCostSavingsNaturalGas: "var(--audette-green-600)",
    totalCarbonPolicyCostSavings: "var(--audette-green-200)",
    annualCarbonPolicyCostSavings: "var(--audette-green-200)",
    annualUtilityCostSavingsElectricity: "var(--audette-green-600)",
    annualUtilityCostSavingsNaturalGas: "var(--audette-green-800)",
    totalUtilityCostSavingsElectricity: "var(--audette-green-600)",
    totalUtilityCostSavingsNaturalGas: "var(--audette-green-800)",
    totalUtilityCostSavings: "var(--audette-green-600)",
    totalIncentives: "var(--audette-blue-400)",
    netCashFlow: "var(--audette-pink)",
    revenue: "var(--audette-blue-200)",
    annualUtilitySavings: "var(--audette-green-600)",
    totalCapex: "var(--audette-gray-500)",
    annualCapex: "var(--audette-gray-500)",

    // Carbon policy cost
    "Savings opportunity": "var(--audette-green-200)",
    "Remaining baseline carbon policy cost": "var(--audette-gray-500)",

    // Measures & endUse
    "Conveying Equipment": "var(--audette-pink-50)",
    Envelope: "var(--audette-blue-400)",
    Heating: "var(--audette-purple-400)",
    heating: "var(--audette-purple-400)",
    "Heating/Cooling": "var(--audette-purple-600)",
    Lighting: "var(--audette-blue-200)",
    lighting: "var(--audette-blue-200)",
    Renewables: "var(--audette-green-600)",
    Renewable: "var(--audette-green-600)",
    Controls: "var(--audette-yellow-200)",
    "Domestic Hot Water": "var(--audette-pink-200)",
    "Domestic hot water": "var(--audette-pink-200)",
    domestic_hot_water: "var(--audette-pink-200)",
    natural_gas: "var(--audette-gray-500)",
    Electrical: "var(--audette-green-200)",
    electricity: "var(--audette-green-200)",
    Ventilation: "var(--audette-pink)",
    Cooling: "var(--audette-purple-150)",
    cooling: "var(--audette-purple-150)",
    outdoor_air_cooling: "var(--audette-purple-300)",
    outdoor_air_heating: "var(--audette-purple-600)",
    Process: "var(--audette-beige-600)",
    process: "var(--audette-beige-600)",
    "Carbon emissions": "var(--audette-gray-600)",
    remainingCarbonEmissions: "var(--audette-yellow-200)",
    "Grid savings": "var(--audette-gray-300)",
    Fans: "var(--audette-pink)",
    fans: "var(--audette-pink)",
    "Plug load": "var(--audette-green-200)",
    plug_load: "var(--audette-green-200)",
    Pumps: "var(--audette-red-600)",
    pumps: "var(--audette-red-600)",
    skin_cooling: "#7CB7F2",
    skin_heating: "#F94646",

    // Roadmap
    recommendations: "var(--audette-pink)",
    recommendationsLight: "var(--audette-pink-100)",
    recommendationsLighter: "var(--audette-pink-50)",
    goal: "var(--audette-purple-300)",
    baseline: "var(--audette-gray-500)",
    baselineLight: "var(--audette-gray-400)",
    baselineLighter: "var(--audette-gray-300)",
} as const;

function getColorsForChartKeys(chartKeys: string[]): string[] {
    let fallbackIndex = 0;
    return chartKeys.map((key) => {
        if (DATA_KEY_COLORS[key]) {
            return DATA_KEY_COLORS[key];
        }

        // Use fallback colors for unmapped keys
        console.warn("KEY IS MISSING DEFAULT COLOR", key);
        const color = FALLBACK_COLORS[fallbackIndex % FALLBACK_COLORS.length];
        fallbackIndex += 1;

        return color;
    });
}

export function getColorMappingForChartKeys(chartKeys: string[]): Array<{ label: string; color: string }> {
    const colors = getColorsForChartKeys(chartKeys);
    return chartKeys.map((key, index) => ({
        label: key,
        color: colors[index],
    }));
}

export function getColorMappingWithoutKeyForChart(chartKeys: string[]) {
    return getColorsForChartKeys(chartKeys);
}

export const FALLBACK_COLORS = [
    "#EF81DA",
    "#EB03AD",
    "#D5BBF9",
    "#7A2AEB",
    "#7CB7F2",
    "#066ECC",
    "#4BF7B5",
    "#00BC98",
    "#3B814B",
    "#F9BF73",
    "#F7931E",
    "#BB6E00",
    "#F94646",
    "#CC303C",
];
